<template>
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :style="{ color: color }"
  >
    <path
      d="M21.25 20L26.25 15M26.25 15L21.25 10M26.25 15L8.75 15M16.25 20V21.25C16.25 23.3211 14.5711 25 12.5 25H7.5C5.42893 25 3.75 23.3211 3.75 21.25V8.75C3.75 6.67893 5.42893 5 7.5 5H12.5C14.5711 5 16.25 6.67893 16.25 8.75V10"
      stroke="currentColor"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "LogoutIcon",
  props: {
    color: {
      type: String,
      default: "#3B4648",
    },
  },
};
</script>
